import { datadogRum } from '@datadog/browser-rum'
// Export for direct import in JS/Vuex
export const ddRum = datadogRum

export default ({ app }, inject) => {
  if (!process.env.DD_APPLICATION_ID) {
    console.log('Datadog initialization skipped: DD_APPLICATION_ID is not set')
    return
  }

  let firebaseSamplingRate = 100

  if (app.$featureFlag.isActive('datadog_rum_sample_rate')) {
    firebaseSamplingRate = Number(app.$featureFlag.value('datadog_rum_sample_rate'))
  }
  ddRum.init({
    applicationId: process.env.DD_APPLICATION_ID,
    clientToken: process.env.DD_CLIENT_TOKEN,
    site: process.env.DD_SITE,
    service: process.env.DD_SERVICE,
    env: process.env.DD_ENV,
    sessionSampleRate: firebaseSamplingRate,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/^(https?:\/\/)?([a-zA-Z0-9-]+\.)?airalo\.com(\/.*)?$/],
    beforeSend: (event) => {
      // Skip errors with [SKIP_DD] marker in the message to avoid double logging
      return !(event.error && event.error.message && event.error.message.includes('[SKIP_DD]'))
    },
  })
  // Inject for usage in Nuxt and Vue components, will be available as this.$ddRum
  inject('ddRum', ddRum)
}
